import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'
import { selectOrganizationsSave } from '../organizationsManagementSelectors'
import { organizationsManagementActions } from '../organizationsManagementSagas'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useComparatorAdd = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation('organizationManagement')
  const { enqueue } = useSnackbar()
  const [name, setName] = useState('')
  const [error, setError] = useState('')
  const { isSelectraAdmin } = useSelector(selectAuthData)
  const save = useSelector(selectOrganizationsSave)

  const basePath = '/organisations/comparator'

  const handleNameChange = event => {
    event.preventDefault()
    setName(event.target.value)
  }

  const handleSave = () => {
    if (!name.trim()) {
      setError(t('comparator.name_required'))
      return
    }
    setError('')
    dispatch({
      type: organizationsManagementActions.SAVE_COMPARATOR,
      name: name.trim(),
      enqueue,
      onSuccess: () => navigate(basePath),
      onError: apiError => {
        const nameErrors = apiError?.validationErrors?.name
        if (nameErrors) {
          setError(Array.isArray(nameErrors) ? nameErrors[0] : nameErrors)
        }
      },
    })
  }

  const handleCancel = () => navigate(basePath)

  return { t, name, error, save, handleNameChange, handleSave, handleCancel, isSelectraAdmin }
}

export default useComparatorAdd
